//External links open in new window
// var links = document.links;
// for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
//   if (links[i].hostname !== window.location.hostname) {
//     links[i].target = '_blank';
//     links[i].rel = 'noreferrer noopener';
//   }
// }

var tabs = $(".plan-tabs-list .plan-tabs-list-item"),
  clickDisabled = false;

tabs.click(function () {
  if (clickDisabled) {
    return;
  }
  if (!$(this).hasClass("active")) {
    var tabNum = $(this).index();
    var nthChild = tabNum + 1;
    $(".plan-tabs-list .plan-tabs-list-item.active").removeClass("active");
    $(this).addClass("active");
    $(".plan-tab-content.active").fadeOut(300, function () {
      $(this).removeClass("active");
      $(".plan-tab-content:nth-child(" + nthChild + ")").addClass("active").fadeIn(300);
    });
  }

  clickDisabled = true;
  setTimeout(function () { clickDisabled = false; }, 500);
});

// Get all accordion items
const $accordionItems = $('.accordion-item');

// Add click event listener to each accordion header
$accordionItems.each(function () {
  const $item = $(this);
  const $header = $item.find('.accordion-header');
  const $content = $item.find('.accordion-content');

  $header.on('click', function () {
    // Toggle the active class
    $item.toggleClass('active');

    // Calculate the content's height
    const contentHeight = $content[0].scrollHeight + 'px';

    if ($item.hasClass('active')) {
      // Expand the accordion
      $content.css('maxHeight', contentHeight);
    } else {
      // Collapse the accordion
      $content.css('maxHeight', '0');
    }
  });
});

class TabsContent extends HTMLElement {
  constructor() {
    super()
    this.tabs = this.querySelectorAll('.tab-title')
    this.contentTabs = this.querySelectorAll('.section-stack')
    this.isToggle = this.getAttribute('toggle')
  }

  connectedCallback() {
    this.tabsInit()

    if(this.isToggle === 'true') {
      this.toggleAccordions()
    }
  }

  tabsInit () {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', ()=> {

        if (tab.classList.contains('active')) return

        this.tabs.forEach(tab => {
          tab.classList.remove('active')
        });

        tab.classList.add('active')

        this.changeContent(tab.dataset.tabId)
      })
    });
  }

  changeContent (id) {
    this.contentTabs.forEach(contentTab => {
      contentTab.classList.remove('active')
    })

    this.querySelector(`.section-stack[data-tab-id="${id}"]`).classList.add('active')
  }

  toggleAccordions() {
    this.contentTabs.forEach(contentTab => {
      const accordions = contentTab.querySelectorAll('details')

      accordions.forEach((accordion, i) => {
        accordion.addEventListener('toggle', ()=> {
          if(accordion.open) {
            accordions.forEach((acc, j) => {
              if(i !== j && acc.open) {
                acc.setAttribute('aria-expanded', 'false')
                acc.removeAttribute('open')
                acc.open = false
              }
            });
          }
        })
      });
    });
  }
}

customElements.define('tabs-content', TabsContent)




